import React from "react";
import CardArticle from "./Cards/CardArticle";

export default function Articles() {
  return (
    <div className="relative w-5/6 mx-auto lg:w-auto lg:mx-0 my-24">
      <h1
        className="text-center text-2xl sm:text-4xl 2xl:text-5xl font-bold mb-14"
        id="articles"
      >
        Artikel Kesehatan
      </h1>
      <div className=" relative space-y-12 sm:grid sm:grid-cols-2 sm:space-y-0 xl:grid xl:grid-cols-4 sm:gap-8 2xl:gap-12 2xl:px-32 lg:gap-10 lg:px-20">
        <CardArticle
          imageSource="assets/artikel1.png"
          title="Vaksin Booster gratis : Gratis untuk seluruh Indonesia!"
        />
        <CardArticle
          imageSource="assets/artikel2.webp"
          title="Pilih 5 Makanan Pembentuk Otot"
        />
        <CardArticle
          imageSource="assets/artikel3.webp"
          title="Benarkah Kecanduan Game Bisa Timbulkan Kejang pada Anak?"
        />
        <CardArticle
          imageSource="assets/artikel4.webp"
          title="Begini Tahapan Basic Skincare dan Rekomendasi Produknya"
        />
      </div>
    </div>
  );
}
